import { render, staticRenderFns } from "./login_password_reset.vue?vue&type=template&id=ba1635e6"
import script from "./login_password_reset.vue?vue&type=script&lang=js"
export * from "./login_password_reset.vue?vue&type=script&lang=js"
import style0 from "./login_password_reset.vue?vue&type=style&index=0&id=ba1635e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports